import reducer from './reducers';

import * as globalOperations from './operations';
import * as globalSelectors from './selectors';

export { globalOperations, globalSelectors };

export default reducer;
